// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"096aaa24","76":"ed9de605","87":"877af36c","401":"6a5481e7","853":"b0747bb4"}[chunkId] + ".css";
};